import Vue from 'vue'
import Active from '@/components/activeModal/active.vue'
import Conversion from '@/components/activeModal/conversion.vue'
import Mission from '@/components/activeModal/mission.vue'
import MissionTwo from '@/components/activeModal/missiontwo.vue'
import MissionAndRainking from '@/components/activeModal/missionAndRainking.vue'
import Wheel from '@/components/activeModal/wheel.vue'
import vm from '../../main'
import { store } from '../../store'
import $ from 'jquery'
import tea from '@/plugins/pandora'


let instance;
const choosecomponent = function(type){
    type.forEach((el, ind) => {
        var elArr = el.split('_');
        var title = elArr[0]
        var awardIdPointer = elArr[1]
        var toiframe = elArr[3]
        if(title == 'wheel'){
            if(elArr[2] == 20202){
                var newCommon = Vue.extend(Active)
            }else{
                var newCommon = Vue.extend(Wheel)
            }
        }else if(title == 'conversion'){
            var newCommon = Vue.extend(Conversion)
        }else if(title == 'mission'){
            if(elArr[2] == 10102){
                var newCommon = Vue.extend(MissionTwo)
            }else{
                var newCommon = Vue.extend(Mission)
            }
            
        }else if(title == 'missionAndRanking'){
            var newCommon = Vue.extend(MissionAndRainking)
        }
        newCommon.use(tea)
        instance = new newCommon({
            el: document.createElement('div'),
            store,
            data(){
                return {
                    awardIdPointer: awardIdPointer,
                    toiframe: toiframe,
                }
            },
            methods:{
                tipConshow(return_msg, toiframe) {
                    toiframe = toiframe ? toiframe : '-1'
                    vm.$children[0].$children[0].toiframeflag = toiframe
                    $(".mask").attr('toiframeflag',toiframe)
                    $(".mask").show()
                    $(".tipContainer").show()
                    $(".awardDetail").hide()  
                    $(".tipDetail").html(return_msg)
                },
                tipConshow2(awardResult,missionflag) {
                    vm.missionflag = missionflag ? missionflag : false
                    $(".mask").show()
                    $(".awardDetail").show()
                    $(".tipContainer").hide()
                    var awardLength = awardResult.length
                    var awardLlist = awardResult
                    var dec = ''
                    if (awardLength <= 3) {
                        $('.awardwrapper').attr('class', 'wrapper')
                        if (awardLength == 1) {
                            if (awardLlist[0].propId == 'GOLD' || awardLlist[0].propId == 'CASH') {
                              dec = '财富已存入您的账户，您可在「 我的 」页面中查看。'
                            } else {
                              dec = '道具已存入您的背包，在背包中您可查看所有道具。'
                            }
                            var desc = awardLlist[0].awardDesc ? awardLlist[0].awardDesc : ''
                            $('.awardDesc').html("<span class = 'yellow'>" + dec + "</span>" + desc)
                            $('.awardDesc').show()
                        } else {
                            $('.awardDesc').show()
                            dec = '您的财富已存入账户，道具已存入背包。财富可在「 我的 」页面中查看，道具可在背包中查看。'
                            $('.yellow').html(dec)
                        }
                    } else {
                        $('.awardDesc').show()
                        dec = '您的财富已存入账户，道具已存入背包。财富可在「 我的 」页面中查看，道具可在背包中查看。'
                        $('.yellow').html(dec)
                        $('.awardwrapper').attr('class', 'wrapper1')
                    }
                    var html = ''
                    var countY = ''
                    $.each(awardResult, (i, item) => {
                        if (item.propId == 'CASH') {//现金
                            item.awardQuantity = item.awardQuantity / 100
                            countY = item.awardQuantity + '元'
                            html += "<div class='box'><img src=" + item.icon + "><p class='resultName'><b class='counTy'>" + countY + "</b>" + item.awardName + "</p></div>"
                        } else if (item.propId == 'GOLD') {//金币
                            item.awardQuantity = item.awardQuantity
                            countY = item.awardQuantity
                            html += "<div class='box'><img class='imgs' src=" + item.icon + "><p class='resultName'><b class='counTy'>" + countY + "</b>" + item.awardName + "</p></div>";
                        } else if (item.propType == 1 || item.propType == 40 || item.propType == 41 || item.propType == 42) {//抵扣券
                            item.awardQuantity = item.awardQuantity
                            countY = item.awardQuantity
                            if (item.param2) {
                              html += "<div class='box'><img src='~assets/images/cash.png'><p class='param1'>¥<b>" + item.couponIcon + "</b></p><p class='param2'>满" + item.useCondition + "元可用</p><p class='resultName'><b class='counTy'>" + countY + "</b>${item.awardName}</p></div>";
                            } else {
                              item.useCondition = '无门槛使用'
                              html += "<div class='box'><img src='~assets/images/cash.png'><p class='param1'>¥<b>" + item.couponIcon + "</b></p><p class='param2'>满" + item.useCondition + "元可用</p><p class='resultName'><b class='counTy'>" + countY + "</b>${item.awardName}</p></div>";
                            }
                        } else {
                            countY = ''
                            item.awardQuantity = item.awardQuantity
                            if (item.awardQuantity == 1) {
                              html += "<div class='box'><img src=" + item.icon + "><p class='resultName'><b class='counTy'>" + countY + "</b>" + item.awardName + "</p></div>"
                            } else {
                              html += "<div class='box'><img src=" + item.icon + "><p class='resultName'><b class='counTy'>" + countY + "</b>" + item.awardName + "</p><span class='num'>" + item.awardQuantity + "</span></div>"
                            }
                        }
                    })
                    $('.wrapper').html(html)
                    $('.awardDetail').css({
                        marginTop:-($('.awardDetail').height()/2)/100+'rem',
                        display: "block"
                    });
                    var activeBagMap = this.$store.state.activeBagMap
                    var cashcount = parseInt(this.$store.state.cashcount) 
                    var goldcount = parseInt(this.$store.state.goldcount)
                    for (var value of awardLlist) {
                        if (value.propId != 'GOLD' && value.propId != 'CASH') {
                            if (!activeBagMap[value.propId]) {
                                var a = {
                                    propId: value.propId,
                                    propNum: parseInt(value.awardQuantity)
                                }
                                activeBagMap[value.propId] = a
                            } else {
                                activeBagMap[value.propId].propNum += parseInt(value.awardQuantity)
                            }
                        } else if (value.propId == 'CASH') {//现金
                            cashcount += parseInt(value.awardQuantity * 100)
                        } else if (value.propId == 'GOLD') {//金币
                            goldcount += parseInt(value.awardQuantity)
                        }
                    }
                    this.$store.commit({
                        type:'setactivebagmap',
                        activeBagMap
                    })
                    this.$store.commit({
                        type:'setcashcount',
                        cashcount
                    })
                    this.$store.commit({
                        type:'setgoldcount',
                        goldcount
                    })
                },
            },
        });
        document.getElementById('idsss').appendChild(instance.$el);
        Vue.nextTick(() => instance.visible = true);
    });
}

export default choosecomponent
